import { render } from "./managePaltform.vue?vue&type=template&id=5e917abc"
import script from "./managePaltform.vue?vue&type=script&lang=js"
export * from "./managePaltform.vue?vue&type=script&lang=js"

import "./managePaltform.vue?vue&type=style&index=0&id=5e917abc&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/NEW-Master-integrated-sugang-admin-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__